import { makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  secondaryColor: string;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    backgroundColor: '#FAFBFC',
    '&::before': {
      content: '""',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `radial-gradient(circle at top right,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(250, 251, 252, 0.8) 100%
      )`,
      zIndex: -2,
    },
  },
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backdropFilter: 'blur(12px)',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    padding: theme.spacing(2, 0),
  },
  headerContent: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: theme.spacing(0, 4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
    },
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: 32,
    width: 'auto',
    objectFit: 'contain',
  },
  businessName: {
    fontSize: '1.125rem',
    fontWeight: 600,
    color: ({ secondaryColor }) => secondaryColor || theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  main: {
    flex: 1,
    width: '100%',
    position: 'relative',
    zIndex: 1,
    maxWidth: 1200,
    margin: '0 auto',
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  footer: {
    position: 'relative',
    zIndex: 10,
    padding: theme.spacing(3, 0),
    marginTop: 'auto',
    backgroundColor: '#FFFFFF',
    borderTop: '1px solid rgba(0, 0, 0, 0.06)',
  },
  footerContent: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: theme.spacing(0, 4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
    },
  },
  footerText: {
    margin: 0,
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  oysterText: {
    color: '#014651',
    fontWeight: 600,
    letterSpacing: '0.2px',
  },
}));
